import DOMPurify from 'dompurify';

export function getPlainText(htmlContent?: string) {
  if (!htmlContent) return '';

  const sanitized = DOMPurify.sanitize(htmlContent, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });
  
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = sanitized;
  const textContent = tempDiv.textContent || '';
  return textContent.replace(/\s+/g, '');
}
